import styled from 'styled-components';

export const Title = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
`;

export const Container = styled.div`
  background-color: #eaeaea;
  padding: 1rem;
  border-radius: 6px;
  margin: 0 0 2rem 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
`;

export const AreaButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
    > button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;
